const DEVICE_ID_KEY = "device_id";
function generateDeviceId() {
  if (
    typeof crypto !== "undefined" &&
    typeof crypto.randomUUID === "function"
  ) {
    return crypto.randomUUID();
  }

  return `web_${Date.now()}_${Math.random().toString(36).substring(2, 14)}`;
}
export function getDeviceId() {
  if (typeof window === "undefined") {
    return null;
  }

  let deviceId = localStorage.getItem(DEVICE_ID_KEY);

  if (!deviceId) {
    deviceId = generateDeviceId();

    localStorage.setItem(DEVICE_ID_KEY, deviceId);
  }

  return deviceId;
}
export function setDeviceId(deviceId) {
  if (typeof window === "undefined" || !deviceId) {
    return;
  }

  localStorage.setItem(DEVICE_ID_KEY, deviceId);
}

export function hasDeviceId() {
  return Boolean(getDeviceId());
}

